import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
<footer className="footer">
  <div className="footer-divider"></div>

  <div className="footer-social">
    <a href="https://github.com/yuosef33" target="_blank" rel="noreferrer">
      <GitHubIcon />
    </a>
    <a href="https://www.linkedin.com/in/yuosefjamal33/" target="_blank" rel="noreferrer">
      <LinkedInIcon />
    </a>
  </div>

  <div className="footer-content">
    <p>©2026 <a href="https://github.com/yuosef33" target="_blank" rel="noreferrer">yousef jamal</a></p>
    <p>All rights reserved</p>
  </div>  
</footer>
  );
}

export default Footer;